export default function removeFatherName(name) {
    const splittedName = name.split(' ');

    return `${splittedName[0]} ${splittedName[2]}`;
}